export default {
  header: {
    menu: 'Menu',
    emergency: 'Kecemasan Pergigian',
    contact:'Hubungi Kami',
    nav: {
      home: 'Laman Utama',
      services: 'Perkhidmatan',
      about: 'Tentang Kami',
      contact: 'Hubungi',
      insurance: 'Panel'
    }
  },
  logo: {
    title: 'Senyum Dental Clinic',
    subtitle: '微笑齿科'
  },
  hero:{
    title:'Selamat Datang ke Klinik Pergigian Senyum ',
    subtitle:'Senyuman anda, tanggungjawab kami',
    consultation:{
      title:'Jadualkan Janji Temu Anda Hari Ini!',
      subtitle:'',
      subsubtitle:'Kami berdedikasi untuk mencipta senyuman yang sihat dan yakin untuk setiap pesakit. Kami beroperasi  di tengah-tengah Kuala Lumpur, kami mengalu-alukan kedatangan anda untuk mendapatkan penjagaan gigi yang profesional dan moden.',
      cta:'Hubungi Kami !'
    }
  },
  about:{
    title:'Selamat Datang Ke Klinik Pergigian Senyum',
    description:{
      first:'Selamat datang ke Klinik Pergigian Senyum! Sesuai dengan nama klinik, kami berdedikasi untuk membawa senyuman yang paling menawan kepada semua pesakit kami. Terletak ditengah kota raya kuala lumpur, Klinik Pergigian Senyum adalah destinasi yang dipercayai untuk penjagaan pergigian yang komprehensif bagi pesakit dari semua peringkat umur.',
      second:'Pasukan kami berpengalaman lebih daripada 15 tahun dalam kepakaran menyediakan perkhidmatan pergigian yang berkualiti tinggi dalam suasana yang mesra dan selesa. Kami juga berpeluang untuk menyertai program radio dan televisyen, ceramah, serta acara-acara lain, di mana kami menjawab soalan mengenai Gigi Bongsu, Implan Pergigian, dan pelbagai topik pergigian yang lain sambil berkongsi pandangan yang berharga.',
      third:'Di Klinik Pergigian Senyum, kami mengutamakan kebajikan pesakit, mewujudkan suasana yang mesra, menarik, dan selesa untuk memastikan setiap pesakit mendapatkan rawatan dan perhatian yang luar biasa. Kami berharap dapat membantu anda untuk mencapai senyuman yang menawan!',
    },
    team:{
      profile:{
        name:'Dr Nicholas Yeo',
        role:'Doktor Gigi',
        description:'BDS (Universiti Malaya)',
      },
      title:'Senarai Doktor',
    },
    location:{
      title:'Cara ke Klinik Pergigian Senyum',
      findus:'Klinik Pergigian Senyum terletak hanya 5 minit berjalan kaki dari KL Sentral. Lokasi kami boleh diakses dengan mudah menggunakan pengangkutan awam seperti LRT, MRT, Monorel, Bas atau Kereta Api melalui bangunan stesen KL Sentral, yang bersambung ke Nu Sentral Shopping Center. Kami optimis untuk membantu anda mendapatkan senyuman yang lebih menawan dengan mudah.(Kami berada di Tingkat 3, sama tingkat dengan Harvey Norman; bertentangan dengan Nyonya Colours)',
    },
    clinic:{
      title:'Galeri Klinik Kami',
    },
    contact:{
      title:'Contact Us',
      form:{
        name:'Name',
        email:'e-mail ',
        message:'Message',
        submit:'Submit'
      }
    }
  },
  insurance:{
    panel: {
      title: 'Klinik Panel',
      subtitle: 'kami adalah klinik rasmi panel syarikat-syarikat berikut.',
    },
    title:'Klinik Panel Syarikat Insuran',
    subtitle:'Kami mengalu-alukan kedatangan anda dan hadir ke Klinik Pergigian Senyum untuk mendapatkan rawatan dan perkhidmatan yang terbaik.',
  },
  services:{
    title:'Perkhidmatan Kami',
    description:'Senarai Perhidmatan dan Rawatan Klinik Pergigian Senyum',
  },
  carousel: {
    slides: {
      smile: {
        alt: 'Pesakit tersenyum gembira',
        caption: 'Mencipta Senyuman Yang Menawan',
        description: 'Alami penjagaan gigi yang selesa dan profesional'
      },
      facility: {
        alt: 'Bilik rawatan moden',
        caption: 'Kemudahan Terkini',
        description: 'Peralatan canggih untuk rawatan yang tepat'
      },
      technology: {
        alt: 'Peralatan pergigian canggih',
        caption: 'Teknologi Moden',
        description: 'Teknologi pergigian terkini untuk hasil yang optimum'
      },
      record: {
        alt: 'Penerima pengiktirafan  Malaysia Book of Record untuk Rawatan Pemutihan Gigi Ultrasonik',
        //caption: 'Antara klinik terbaik di Malaysia untuk pemutihan gigi',
        //description: 'Kami juga berbesar hati kerana telah memperoleh tempat yang terhormat dalam THE MALAYSIA BOOK OF RECORDS, yang mengiktiraf pencapaian luar biasa kami dalam Pengikisan dan Penggilapan Ultrasonik Tanpa Kesakitan dan Pemutihan Gigi.'
        caption:'',
        description:''
      }
    }
  },
  footer:{
    address:{
      text:'Hubungi Kami', 
      note:'Kami berada di Tingkat 3, tingkat yang sama dengan Harvey Norman; Bertentangan dengan Nyonya Colours.',
    },
    openinghours:{
      text:'Waktu Operasi',
      dailies:'Setiap Hari',
      description:'Buka setiap hari termasuk cuti umum', 
    },
    links:{
      title:'Pautan Pantas',
    }
  } 

  // ... rest of the translations remain unchanged
}